<ds-modal
  [id]="vehicleAssignmentModalId"
  [closeOthers]="true"
  [maxWidth]="modalWidth"
  (onCloseModalEvent)="cancelEvent.emit(); close()"
>
  <div>
    <h2 class="text-center neutral-600-text">
      <b class="block"> {{ headingMessageContent }}</b>
    </h2>

    <div class="row pad-20">
      <div class="column twelve">
        <div class="flex items-center">
          <div>
            <p class="margin-0">
              {{ bodyMessageContent }}
            </p>
          </div>
        </div>
      </div>

      <div class="column twelve pad-top-20 flex items-center justifyButtons">
        <button
          class="margin-left-8 margin-right-8 -outline-white"
          ds-button
          aria-label="Cancel"
          (click)="cancelEvent.emit(); close()"
        >
          Cancel
        </button>
        <button ds-button aria-label="Switch" (click)="switchEvent.emit(); close()">Switch</button>
      </div>
    </div>
  </div>
</ds-modal>
